/**
 * tg-sofready-users-hero.js
 *
 * Playback behavior for the <tg-sofusers-hero> custom element
 * (sections/tg-sofready-users-hero.liquid). Isolated to this element only —
 * no document-level listeners, no globals, no overlap with
 * assets/tg-sofready-vsl.js (read-only visual/behavioral reference, not
 * shared code) or any other section's video/cart/purchase logic.
 *
 * - Muted autoplay while the video is scrolled into view (skipped for
 *   prefers-reduced-motion).
 * - Tapping the overlay unmutes and hides the tap-for-sound prompt.
 * - The CTA is a plain anchor to #product--section; smooth scrolling and
 *   header clearance are handled entirely by CSS
 *   (assets/tg-sofready-users-hero.css), so there is no scroll-to-target
 *   code here.
 */
(function () {
  function boot(root) {
    var player = root.querySelector('.tg-sofusers-hero__player video');
    var overlay = root.querySelector('[data-tgsofuh-overlay]');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!player || !overlay) return;

    root.classList.add('tg-sofusers-hero--idle');

    if (!reducedMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              player.muted = true;
              var playPromise = player.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
              root.classList.remove('tg-sofusers-hero--idle');
            } else {
              player.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(player);
    }

    overlay.addEventListener('click', function () {
      player.muted = false;
      player.controls = true;
      var playPromise = player.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
      overlay.hidden = true;
      root.classList.remove('tg-sofusers-hero--idle');
    });
  }

  function init() {
    document.querySelectorAll('tg-sofusers-hero').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
